// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const session_id = m ? decodeURIComponent(m[1]) : null;

    if (!session_id) {
      navigate("/", { replace: true });
      return;
    }

    apiClient
      .post("/auth/session", { session_id })
      .then(({ data }) => {
        if (data?.session_token) {
          try { localStorage.setItem("aurafx_token", data.session_token); } catch { /* noop */ }
        }
        if (data?.user) setUser(data.user);
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true, state: { user: data?.user } });
      })
      .catch(() => navigate("/", { replace: true }));
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 mx-auto mb-4 border-2 border-white/20 border-t-[color:var(--accent)] rounded-full animate-spin" />
        <p className="text-sm text-white/60 font-mono-num">Authenticating…</p>
      </div>
    </div>
  );
}
